import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { fetchNhisChupyakPendingCount } from "@core/api/chupyakApi"

interface NhisChupyakPendingState {
  pendingCount: number
  loading: boolean
  error: string | null
}

const initialState: NhisChupyakPendingState = {
  pendingCount: 0,
  loading: false,
  error: null,
}

const nhisChupyakPendingSlice = createSlice({
  name: "nhisChupyakPending",
  initialState,
  reducers: {
    setNhisChupyakPendingCount(state, action: PayloadAction<number>) {
      state.pendingCount = action.payload
      state.error = null
    },
    incrementNhisChupyakPendingCount(state) {
      state.pendingCount += 1
    },
    decrementNhisChupyakPendingCount(state) {
      if (state.pendingCount > 0) {
        state.pendingCount -= 1
      }
    },
    setNhisChupyakPendingLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setNhisChupyakPendingError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
    resetNhisChupyakPendingCount(state) {
      state.pendingCount = 0
      state.loading = false
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchNhisChupyakPendingCount.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchNhisChupyakPendingCount.fulfilled, (state, action) => {
        state.loading = false
        state.pendingCount = action.payload
        state.error = null
      })
      .addCase(fetchNhisChupyakPendingCount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "첩약건보 미제출 건수 조회에 실패했습니다."
      })
  },
})

export const {
  setNhisChupyakPendingCount,
  incrementNhisChupyakPendingCount,
  decrementNhisChupyakPendingCount,
  setNhisChupyakPendingLoading,
  setNhisChupyakPendingError,
  resetNhisChupyakPendingCount,
} = nhisChupyakPendingSlice.actions

export default nhisChupyakPendingSlice.reducer